import { style } from 'typestyle';
import { ORANGE, borderHighlightColor, ORANGE_LIGHT, ORANGE_DARK } from 'src/utils/Style/Theme';

const BORDER = '2px solid';
const DISABLED_BORDER = `2px solid ${ORANGE_LIGHT.toHexString()}`;

export const pageStyle = style({
  textAlign: 'center',
});

export const userMenuItemStyle = style({
  display: 'inline-flex',
  alignItems: 'center',
  gap: '0.5rem',
});

export const containerStyle = style({
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'center',
  position: 'relative',
  top: '40vh',
  borderColor: ORANGE.toHexString(),
  $nest: {
    '& > a, & > section': {
      textAlign: 'center',
      margin: '1rem',
    },
    '& a, & > section': {
      color: ORANGE.toHexString(),
    },
    '& a:hover, & section:hover': {
      cursor: 'pointer',
      borderColor: ORANGE_DARK.toHexString(),
      color: ORANGE_DARK.toHexString(),
    },
    label: {
      color: 'black',
    },
  },
});

export const bubbleIconStyle = style({
  border: BORDER,
  borderRadius: '100%',
  margin: '1rem',
});

export const bubbleStyle = style({
  flex: '0 0 10rem',
  width: '10rem',
  minWidth: 0,
});

export const bubbleTitleStyle = style({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '2.5rem',
  lineHeight: 1.2,
  overflowWrap: 'anywhere',
});

export const nestedBubbleTitleStyle = style({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  maxWidth: '100%',
  minWidth: 0,
  gap: '0.4em',
  $nest: {
    label: {
      minWidth: 0,
      overflowWrap: 'anywhere',
    },
    svg: {
      flexShrink: 0,
    },
  },
});

export const nestedBubbleTextStyle = style({
  minWidth: 0,
  overflowWrap: 'anywhere',
  textAlign: 'left',
});

export const nestedBubbleListItemStyle = style({
  $nest: {
    '&&': {
      alignItems: 'center',
      justifyContent: 'center',
      padding: 0,
    },
  },
});

export const nestedBubbleLinkStyle = style({
  margin: 0,
});

export const nestedBubbleListIconStyle = style({
  $nest: {
    '&&': {
      alignItems: 'center',
      flex: '0 0 46px',
      minWidth: '40px',
    },
  },
});

export const nestedBubbleIconStyle = style({
  $nest: {
    '&&': {
      border: 'none',
      width: '30px',
      height: 'auto',
      overflow: 'visible',
      display: 'flex',
      alignItems: 'center',
    },
  },
});

export const disabledStyle = style({
  color: 'gray',
  textAlign: 'center',
  cursor: 'not-allowed',
  $nest: {
    'span.disabled': {
      border: DISABLED_BORDER,
      borderRadius: '100%',
      color: borderHighlightColor,
      borderColor: ORANGE_LIGHT.toString(),
    },
    label: {
      color: 'grey',
      cursor: 'not-allowed',
    },
    i: {
      color: ORANGE_LIGHT.toString(),
    },
    'i:hover': {
      color: ORANGE_LIGHT.toString(),
    },
  },
});

export const iconContainer = style({
  height: '5rem',
  width: '5rem',
  border: `1px solid ${ORANGE.toString()}`,
  borderRadius: '100%',
});

export const brandLogoCentered = style({
  width: 200,
  transform: 'translateX(-38%)',
  position: 'absolute',
  top: '26%',
});
